import { createSelector } from 'reselect';

export const getState = (state) => state.createOffer;

export const getCreateOffer = createSelector(getState, ({ offer }) => offer);
